import React, { useMemo } from "react";
import {
  View,
  Page,
  Text,
  Link,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import PlayingTimePDF from "./PlayingTimePDF.jsx";

const barHeight = "15px";

export default function Position({ rotation, position, start, end }) {
  const { minutes, periodLength, players, period } = rotation;

  const minutesAtThisPosition = useMemo(
    () =>
      minutes.filter(
        (minute) =>
          minute.position === position &&
          minute.end <= end &&
          minute.start >= start
      ),

    [minutes, position]
  );

  /*
  let tempStart =
    props.start +
    (Math.min(
      Math.max(0, dragStatus.dragX),
      barDimensions.width - dragStatus.width
    ) /
      barDimensions.width) *
      (props.end - props.start);

  let tempDuration =
    (dragStatus.width / barDimensions.width) * (props.end - props.start);

  let tempEnd = Math.min(tempStart + tempDuration, props.end);

  let snap = Helper.checkforSnap(
    minutesAtThisPosition,
    tempStart,
    tempEnd,
    snapDistance,
    periodLength,
    dragStatus.minuteId,
    props.position
  );

  let left =
    barDimensions.width *
    ((snap.newCoords.start - props.start) / (props.end - props.start));

  let width =
    barDimensions.width *
    ((snap.newCoords.end - snap.newCoords.start) / (props.end - props.start));

  const [currentTime, setCurrentTime] = useState(null);
 */

  return (
    <View style={{ position: "relative" }}>
      <View
        style={{
          position: "absolute",
          left: "-20px",
          height: barHeight,
          //backgroundColor: "pink",
          width: "20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Text
          style={{
            position: "absolute",
            color: "#333333",
            fontSize: 8,
            //lineHeight: barHeight,
            //backgroundColor: "pink",
          }}
        >
          {rotation.positionLabels[position]}
        </Text>
      </View>

      <View
        style={{
          marginBottom: 5,
          backgroundColor: "#f5f5f5",
          height: barHeight,
        }}
      >
        {minutesAtThisPosition.map((minute) => (
          <PlayingTimePDF
            minutes={minutes}
            periodLength={periodLength}
            period={period}
            barHeight={barHeight}
            key={minute.minuteId}
            player={players.find((x) => x.id === minute.id)}
            minute={minute}
            start={start}
            end={end}
          />
        ))}
      </View>
    </View>
  );
}
